import { Injectable, inject } from '@angular/core'
import { Actions, createEffect } from '@ngrx/effects'
import { Store } from '@ngrx/store'
import { State } from '../state'
import { DailyReportColumnService } from '../../services/daily-report-column.service'
import { AsyncEffects } from '../../../shared/utils/redux/async.effects'
import { DailyReportColumnsActions } from './daily-report-columns.actions'

@Injectable()
export class DailyReportColumnsEffects {
  private actions$ = inject(Actions)
  private store = inject<Store<State>>(Store)
  private effectFactory = inject(AsyncEffects)
  private service = inject(DailyReportColumnService)

  loadDailyReportColumns$ = createEffect(() =>
    this.effectFactory.asyncEffect(
      DailyReportColumnsActions.loadDailyReportColumns,
      () => this.service.getAll(),
    ),
  )
}
